export default __webpack_public_path__ + "static/media/finaClosed.8888b59f.jpg";